import Vue from "vue";

// Global event bus
const EventBus = new Vue({
    data: function() {
        return {
            listenersWithBinding: {}
        };
    },
    methods: {
        /**
         * Bind event.
         *
         * @param {String} name The event name to bind to.
         * @param {Function} fct The function to fire when event trigger.
         * @param {Object} scope The object scope.
         */
        $onWithBinding: function(name, fct, scope) {
            // Creating if needed the listener parent object
            if (!this.listenersWithBinding.hasOwnProperty(name)) {
                Vue.set(this.listenersWithBinding, name, []);
            }

            // Adding the binding
            const result = fct.bind(scope);
            this.listenersWithBinding[name].push({
                fct: fct,
                scope: scope,
                result: result
            });

            // Applying binding
            this.$on(name, result);
        },

        /**
         * Unbind event.
         *
         * @param {String} name The event name to bind to.
         * @param {Function} fct The function to unbind to given event trigger. If null/not set,
         *   unbind all function related to this event (only concern element binded using
         *   $onWithBinding function)
         * @param {Object} scope The object scope (optional).
         */
        $offWithBinding: function(name, fct, scope) {
            // Nothing to do in this case...
            if (!this.listenersWithBinding.hasOwnProperty(name)) {
                return;
            }

            var listeners = this.listenersWithBinding[name],
                i = listeners.length,
                listener;
            if (typeof fct === "function") {
                while(i--) {
                    listener = listeners[i];
                    if (listener.fct === fct && (!scope || listener.scope === scope)) {
                        this.$off(name, listener.result);
                        listeners.splice(i, 1);
                    }
                }
            } else {
                while(i--) {
                    listener = listeners[i];
                    this.$off(name, listener.result);
                    listeners.splice(i, 1);
                }
            }

            // We clean
            if (this.listenersWithBinding[name].length === 0) {
                Vue.delete(this.listenersWithBinding, name);
            }
        }
    }
});

export default EventBus;